const styles = theme => ({
  titleWrapper: {
    alignItems: 'center',
    display: 'flex',
    marginBottom: theme.spacing.unit * 3
  },
  title: {
    flex: 1
  },
  tableRow: {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'rgba(12,31,44, 0.04)'
    }
  },
  divider: {
    marginBottom: theme.spacing.unit * 4
  },
  fieldsWrapper: {
    borderBottom: '1px dashed rgba(12,31,44,0.12)',
    marginBottom: theme.spacing.unit * 3
  },
  formWrapped: {
    paddingBottom: `${theme.spacing.unit}px !important`
  },
  formTitle: {
    marginBottom: theme.spacing.unit * 3
  },
  actionsWrapper: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  actionButtonDisabled: {
    backgroundColor: '#D4D8DC'
  }
});

export default styles;
